import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import ExportButton from '~/components/Button/ExportButton';
import Wind from './Wind';
import Transport from './Transport';
import Item from './Item';
import Pier from './Pier';

const lessor = t => {
  try {
    const obj = JSON.parse(t);
    return `${obj[0].a}${obj[0].b}`;
  } catch (err) {
    return '';
  }
};

const App = () => {
  const dispatch = useDispatch();
  const getData = () => Actions_Wind.Gis.getWinds(dispatch);
  const GisWinds1 = useSelector(state => state.data.GisWinds1 || []);
  const GisWinds2 = useSelector(state => state.data.GisWinds2 || []);
  const GisWinds3 = useSelector(state => state.data.GisWinds3 || []);

  const onExport = () => {
    if ((GisWinds1.length === 0) && (GisWinds2.length === 0) && (GisWinds3.length === 0)) {
      alert('無匯出資料');
    } else {
      excel.outputAryAry({
        data: GisWinds1.map((o = {}) => ([
          o.dock,
          o.dock_num,
          o.windcontract_data?.windfield_simplename,
        ])),
        header: [
          '港口',
          '碼頭編號',
          '使用風場',
        ],
        fileName: '多風場碼頭系統_風力機預組裝碼頭',
      });

      excel.outputAryAry({
        data: GisWinds2.map((o = {}) => ([
          o.dock,
          o.dock_num,
          o.windcontract_data?.windfield_simplename,
        ])),
        header: [
          '港口',
          '碼頭編號',
          '使用風場',
        ],
        fileName: '多風場碼頭系統_運維碼頭',
      });

      excel.outputAryAry({
        data: GisWinds3.map((o = {}) => ([
          o.dock,
          (o.near_land === '其他') ? `${o.near_land}_${o.near_land_other}` : o.near_land,
          o.windcontract_data?.windfield_simplename,
          o.store_part,
          o.item_num,
          o.expect_space,
          lessor(o.lessor),
          o.rent_start_date,
          o.rent_end_date,
        ])),
        header: [
          '港口',
          '碼頭後線土地',
          '使用風場',
          '存放部件',
          '數量',
          '預計存放空間需求',
          '出租方',
          '租期起始',
          '租期結束',
        ],
        fileName: '多風場碼頭系統_零組件存放碼頭',
      });
    }
  };

  useEffect(() => { getData(); }, []);
  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='多風場碼頭系統' />

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <SearchBar style={{ marginTop: 16, marginBottom: 25 }} text='碼頭資訊' defaultOpen>
        <div style={{ display: 'flex', marginLeft: 52, marginRight: 52, marginBottom: 20 }}>
          <Wind />
          <div style={{ flex: 1 }} />
          <Transport />
        </div>
        <Item />
      </SearchBar>

      <Pier />

    </div>
  );
};

export default App;
